"use client"

import { motion } from "framer-motion"
import axios from "axios"
import { useState, useEffect } from "react"
import "./styles.css" // Import the CSS file

const BouncingBanner = () => {
  // State to store the banner message
  const [bannerMessage, setBannerMessage] = useState("")
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const baseUrl = process.env.REACT_APP_APP_URL // Get base URL from environment variable

  // Fetch data from the API when the component mounts
  useEffect(() => {
    // Retrieve the Bearer token from localStorage
    const token = localStorage.getItem("CC_Token")

    // If the token is available, set the Authorization header for the request
    const headers = token ? { Authorization: `Bearer ${token}` } : {}

    // Make the API request to get the banner data
    axios
      .get(`${baseUrl}/api/banners`, { headers })
      .then((response) => {
        // Assuming the response contains an array and we want the first banner's text
        if (response.data && response.data.length > 0) {
          setBannerMessage(response.data[0].text) // Access the 'text' field of the first item
        } else {
          setError("No banner data available.")
        }
        setLoading(false) // Set loading to false when data is fetched
      })
      .catch((error) => {
        console.error("There was an error fetching the banner data:", error)
        setError("Failed to load banner data") // Handle errors gracefully
        setLoading(false)
      })
  }, []) // Empty dependency array means this runs once when the component mounts

  // Calculate animation duration based on message length
  const calculateDuration = () => {
    if (loading || error) return 35 // Default duration for loading/error states

    // For actual messages, adjust speed based on length
    // Shorter messages move slower, longer messages move faster
    // Formula: inverse relationship between length and duration
    // Clamped between 10 (fastest) and 35 (slowest)
    return Math.max(10, Math.min(35, 35 * (100 / Math.max(bannerMessage.length, 20))))
  }

  // Display loading, error, or the banner message
  return (
    <div className="bouncing-banner">
      <div className="banner-wrapper">
        <motion.div
          className="banner-content"
          animate={{ x: ["100%", "-100%"] }}
          transition={{
            repeat: Number.POSITIVE_INFINITY,
            duration: calculateDuration(),
            ease: "linear",
          }}
        >
          {loading ? "Loading..." : error || bannerMessage} {/* Handle loading and error states */}
        </motion.div>
      </div>
    </div>
  )
}

export default BouncingBanner
